/**
 * Mirror of staff-api card terminal reference rules (#1321 interim).
 * Keep in sync with services/staff-api/src/lib/card-payment-reference.ts.
 */

export const CARD_PAYMENT_REFERENCE_MIN_LENGTH = 4;
export const CARD_PAYMENT_REFERENCE_MAX_LENGTH = 100;

export function normalizeCardPaymentReference(raw: string): string {
  return raw.trim().replace(/\s+/g, ' ').toUpperCase();
}

export function isValidCardPaymentReference(raw: string): boolean {
  const normalized = normalizeCardPaymentReference(raw);
  if (
    normalized.length < CARD_PAYMENT_REFERENCE_MIN_LENGTH
    || normalized.length > CARD_PAYMENT_REFERENCE_MAX_LENGTH
  ) {
    return false;
  }
  if (/^\d{13,19}$/.test(normalized.replace(/\s/g, ''))) {
    return false;
  }
  if (!/^[A-Z0-9./_\- ]+$/.test(normalized)) {
    return false;
  }
  const alnumCount = (normalized.match(/[A-Z0-9]/g) ?? []).length;
  return alnumCount >= CARD_PAYMENT_REFERENCE_MIN_LENGTH;
}
